import React, { useState, useEffect } from 'react';

const CookieBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookieAccepted');
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50">
      <div className="bg-white dark:bg-dark-900 rounded-2xl shadow-card border border-dark-100 dark:border-dark-800 p-5">
        <p className="text-sm text-dark-600 dark:text-dark-400 leading-relaxed mb-4">
          Acest site foloseste cookie-uri pentru a imbunatati experienta de navigare.
        </p>
        <div className="flex gap-2">
          <button
            onClick={accept}
            className="flex-1 px-4 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary-700 transition-colors"
          >
            Accept
          </button>
          <a
            href="/cookies"
            className="flex-1 px-4 py-2.5 rounded-xl bg-dark-100 dark:bg-dark-800 text-dark-700 dark:text-dark-300 text-sm font-medium text-center hover:bg-dark-200 dark:hover:bg-dark-700 transition-colors"
          >
            Detalii
          </a>
        </div>
      </div>
    </div>
  );
};

export default CookieBar;
